import { memoize } from '@exodus/basic-utils';
const resultFunction = (loading, rates, getAsset) => memoize((assetName) => {
    if (loading)
        return false;
    const isValid = (assetName) => {
        const asset = getAsset(assetName);
        if (!asset)
            return false;
        const ticker = asset.ticker;
        const rate = rates[ticker];
        if (!rate)
            return false;
        if (!rate.price)
            return false;
        return rates[ticker]?.invalid !== true;
    };
    const asset = getAsset(assetName);
    if (!asset)
        return false;
    if (asset.isCombined) {
        return asset.combinedAssetNames.some(isValid);
    }
    return isValid(assetName);
});
const getIsRateAvailableSelector = {
    id: 'getIsRateAvailable',
    resultFunction,
    dependencies: [
        //
        { selector: 'loading' },
        { selector: 'fiatRates' },
        { module: 'assets', selector: 'getAsset' },
    ],
};
export default getIsRateAvailableSelector;
